import { render, staticRenderFns } from "./vulnerability_report_tab.vue?vue&type=template&id=512c27f5&"
import script from "./vulnerability_report_tab.vue?vue&type=script&lang=js&"
export * from "./vulnerability_report_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports